export default __webpack_public_path__ + "static/media/mepExpand1.37b38db7.jpg";